module.exports = __webpack_public_path__ + "img/nas.606690e8.png";